export const BANK_BRANCHES = {
	"Bács-Kiskun": {
		"Bajai Fiók (6500 Baja, Déri Frigyes sétány 1–3)": "Bajai", //
		"Kecskeméti Fiók (6000 Kecskemét, Csányi u. 1–3.)": "Kecskeméti", //
	},
	Baranya: {
		"Pécs II. Fiók (7621 Pécs, Irgalmasok u. 3/1.)": "Pécs II.", //
	},
	Békés: {
		"Békéscsabai Fiók (5600 Békéscsaba, Andrássy út 2.)": "Békéscsabai", //
		"Orosházi Fiók (5900 Orosháza, Széchenyi tér 1.)": "Orosházi", //
	},
	"Borsod-Abaúj-Zemplén": {
		"Kazincbarcikai Fiók (3700 Kazincbarcika, Egressy Béni út 1/c.)": "Kazincbarcikai", //
		"Miskolc I. Fiók (3525 Miskolc, Déryné u. 11.)": "Miskolci", //
	},
	"Budapest II. kerület": {
		"Fényes Elek Fiók (1024 Budapest, Petrezselyem u. 2–8.)": "Fényes Elek", //
		"Lövőház utcai Fiók (1024 Budapest, Lövőház u. 7–9.)": "Lövőház utcai", //
		"Medve utcai Fiók (1027 Budapest, Medve u. 4–14.)": "Medve utcai", //
		"Rózsakerti Fiók (Rózsakert Üzletház 1026 Budapest, Gábor Áron u. 74–78.)": "Rózsakerti", //
	},
	"Budapest III. kerület": {
		"Flórián téri Fiók (1033 Budapest, Flórián tér 6–9.)": "Flórián téri", //
	},
	"Budapest IV. kerület": {
		"Újpesti Fiók (1043 Budapest, István u. 8.)": "Újpesti", //
	},
	"Budapest V. kerület": {
		"Szent István körúti Fiók (1055 Budapest, Szent István körút 15.)": "Szent István körúti", //
	},
	"Budapest VI. kerület": {
		"Bajcsy Fiók (1065 Budapest, Bajcsy-Zsilinszky Endre út 5–7.) - ZÁRVA": "Bajcsy", //
		"Westend Fiók (1062 Budapest, Váci út 1–3.)": "Westend", //
	},
	"Budapest VII. kerület": {
		"Blaha Lujza téri Fiók (1073 Budapest, Erzsébet krt. 2.)": "Blaha Lujza téri", //
		"Károly körúti Fiók (1075 Budapest, Károly krt. 3/b.)": "Károly körúti", //
	},
	"Budapest IX. kerület": {
		"Ferenc körúti Fiók (1094 Budapest, Ferenc krt. 15.) - ZÁRVA": "Ferenc körúti", //
	},
	"Budapest XI. kerület": {
		"Allee Fiók (1117 Budapest, Október 23. u. 6–8.) - ZÁRVA": "Allee", //
		"Tétényi úti Fiók (1117 Budapest, Tétényi út 63.)": "Tétényi úti", //
	},
	"Budapest XII. kerület": {
		"Kékgolyó utcai Fiók (1122 Budapest, Kékgolyó u. 1.)": "Kékgolyó utcai", //
	},
	"Budapest XIV. kerület": {
		"Bosnyák téri Fiók (1149 Budapest, Bosnyák tér 9.)": "Bosnyák téri", //
		"Örs vezér téri Fiók (1148 Budapest, Örs vezér tere 24.)": "Örs vezér téri", //
	},
	"Budapest XV. kerület": {
		"Újpalotai Fiók (1156 Budapest, Páskomliget u. 6.)": "Újpalotai", //
	},
	"Budapest XVI. kerület": {
		"Mátyásföldi Fiók (1165 Budapest, Veres Péter út 105–107.) - ZÁRVA": "Mátyásföldi", //
	},
	"Budapest XVII. kerület": {
		"Rákoskeresztúri Fiók (1173 Budapest, Pesti út 170.)": "Rákoskeresztúri", //
	},
	"Budapest XVIII. kerület": {
		"Pestszentlőrinc II. Fiók (1184 Budapest, Üllői út 366.)": "Pestszentlőrinci", //
	},
	"Budapest XIX. kerület": {
		"KÖKI Fiók (1191 Budapest, Vak Bottyán u. 75. A–C)": "KÖKI", //
	},
	"Budapest XX. kerület": {
		"Pesterzsébeti Fiók (1203 Budapest, Kossuth L. u. 21–29.) - ZÁRVA": "Pesterzsébeti", //
	},
	"Budapest XXI. kerület": {
		"Csepeli Fiók (1211 Budapest, Kossuth Lajos u. 82.)": "Csepeli", //
	},
	"Budapest XXII. kerület": {
		"Campona Fiók (1222 Budapest, Nagytétényi út 37–43.)": "Campona",
	},
	Csongrád: {
		"Hódmezővásárhelyi Fiók (6800 Hódmezővásárhely, Deák Ferenc u. 15.)": "Hódmezővásárhelyi", //
		"Szeged I. Fiók (6720 Szeged, Kiss Menyhért u. 1.)": "Szeged I.", //
	},
	Fejér: {
		"Dunaújvárosi Fiók (2400 Dunaújváros, Dózsa György u. 2.)": "Dunaújvárosi", //
		"Székesfehérvár I. Fiók (8000 Székesfehérvár, Távirda u. 2/b.)": "Székesfehérvári", //
	},
	"Győr-Moson-Sopron": {
		"Győr I. Fiók (9021 Győr, Aradi vértanúk útja 10.)": "Győr I.", //
		"Soproni Fiók (9400 Sopron, Várkerület 73.)": "Soproni", //
	},
	"Hajdú-Bihar": {
		"Debrecen Unió Fiók (4025 Debrecen, Piac u. 1–3.)": "Debrecen III.", //
	},
	Heves: {
		"Egri Fiók (3300 Eger, Érsek u. 1.)": "Egri", //
		"Gyöngyösi Fiók (3200 Gyöngyös, Szent Bertalan u. 1.)": "Gyöngyösi", //
	},
	"Jász-Nagykun-Szolnok": {
		"Szolnoki Fiók (5000 Szolnok, Szapáry u. 22.)": "Szolnoki", //
	},
	"Komárom-Esztergom": {
		"Esztergomi Fiók (2500 Esztergom, Széchenyi tér 24.)": "Esztergomi", //
		"Tatabányai Fiók (2800 Tatabánya, Fő tér 10.)": "Tatabányai", //
	},
	Nógrád: {
		"Salgótarjáni Fiók (3100 Salgótarján, Rákóczi u. 1–9.)": "Salgótarjáni", //
	},
	Pest: {
		"Budaörsi Fiók (2040 Budaörs, Szabadság út 93.) - ZÁRVA": "Budaörsi", //
		"Dunakeszi Fiók (2120 Dunakeszi, Casalgrande tér 4.)": "Dunakeszi", //
		"Érdi Fiók (2030 Érd, Budai út 22.)": "Érdi", //
		"Gödöllői Fiók (2100 Gödöllő, Szabadság tér 16–17.)": "Gödöllői", //
		"Szentendrei Fiók (2000 Szentendre, Fő tér 14.)": "Szentendrei", //
		"Szigetszentmiklósi Fiók (2310 Szigetszentmiklós, Bajcsy-Zsilinszky u. 1/A(1))": "Szigetszentmiklósi", //
		"Törökbálinti Fiók (2045 Törökbálint, Bajcsy-Zsilinszky u. 75.)": "Törökbálinti", //
		"Váci Fiók (2600 Vác, Széchenyi u. 4–6.)": "Váci", //
		"Vecsési Fiók (2220 Vecsés, Telepi út 58.)": "Vecsési", //
	},
	Somogy: {
		"Kaposvári Fiók (7400 Kaposvár, Fő u. 13.)": "Kaposvári", //
		"Siófoki Fiók (8600 Siófok, Fő tér 3.)": "Siófoki", //
	},
	"Szabolcs-Szatmár-Bereg": {
		"Mátészalkai Fiók (4700 Mátészalka, Kazinczy u. 2.)": "Mátészalkai", //
		"Nyíregyháza I. Fiók (4400 Nyíregyháza, Hősök tere 7.)": "Nyíregyházi", //
	},
	Tolna: {
		"Szekszárdi Fiók (7100 Szekszárd, Garay tér 1.)": "Szekszárdi", //
	},
	Vas: {
		"Szombathelyi Fiók (9700 Szombathely, Fő tér 33.)": "Szombathelyi", //
	},
	Veszprém: {
		"Veszprémi Fiók (8200 Veszprém, Szeglethy u. 1.)": "Veszprémi", //
	},
	Zala: {
		"Nagykanizsai Fiók (8800 Nagykanizsa, Király u. 53.)": "Nagykanizsai", //
		"Zalaegerszegi Fiók (8900 Zalaegerszeg, Kossuth Lajos u. 8–10.)": "Zalaegerszegi", //
	},
};
